import { CommonModule } from "@angular/common";
import { Component, EventEmitter, inject, Output } from "@angular/core";

import { finalize, Observable } from "rxjs";

import { MonthCardComponent } from "@features/home/components/month-card/month-card.component";
import { SummaryCardsService } from "@features/home/services/summary-cards.service";
import { MonthCardData, RequestState, SummaryCards } from "@shared/models";

@Component({
  selector: "app-summary-cards",
  standalone: true,
  imports: [MonthCardComponent, CommonModule],
  templateUrl: "./summary-cards.component.html",
  styleUrl: "./summary-cards.component.scss",
})
export class SummaryCardsComponent {
  summaryCardsService = inject(SummaryCardsService);

  @Output() dataLoaded = new EventEmitter<boolean>();

  loadingData: MonthCardData = {} as MonthCardData;

  summaryCardsData$: Observable<RequestState<SummaryCards>> = this.summaryCardsService.getSummaryCardsData().pipe(
    finalize(() => {
      this.dataLoaded.emit(true);
    })
  );
}
